import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './verfyEmail.css';
import { useDispatch, useSelector } from 'react-redux';
import { verifyEmailUser, resendVerificationUser } from '../../rtk/thunks/authThunk';
import { trackSignUp } from '../../utils/analytics';

const VerifyEmail = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { loading, error, message } = useSelector((state) => state.auth);
	const [formData, setFormData] = useState({ email: '', code: '' });

	useEffect(() => {
		const savedEmail = localStorage.getItem('pending_verification_email');
		if (savedEmail) {
			setFormData((prev) => ({ ...prev, email: savedEmail }));
		}
	}, []);

	const formatError = (value) => {
		if (!value) return '';
		if (typeof value === 'string') return value;
		if (Array.isArray(value)) return value.filter(Boolean).join(' ');

		return (
			value.detail ||
			value.message ||
			value.non_field_errors?.[0] ||
			value.email?.[0] ||
			value.code?.[0] ||
			'Email verification failed. Please try again.'
		);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			await dispatch(verifyEmailUser(formData)).unwrap();
			trackSignUp();
			localStorage.removeItem('pending_verification_email');
			navigate('/sign-in', { replace: true });
		} catch (err) {
			// error surfaced in slice
		}
	};

	const handleResendCode = async () => {
		try {
			await dispatch(resendVerificationUser({ email: formData.email })).unwrap();
		} catch (err) {
			// error surfaced in slice
		}
	};

	return (
		<div className="verify-email-page">
			<div className="verify-email-card">
				<div className="verify-email-header">
					<p className="verify-email-eyebrow">Account security</p>
					<h2>Verify your email</h2>
					<p className="verify-email-subtitle">Enter the code we sent to your inbox to finish setting up your account.</p>
				</div>
				<div className="form-content">
					<form onSubmit={handleSubmit}>
						<div className="input-group">
							<input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
						</div>
						<div className="input-group">
							<input type="text" name="code" placeholder="Verification Code" value={formData.code} onChange={handleChange} required />
						</div>

						<p className="verification-instructions">Please check your inbox and spam folder. If the code hasn’t arrived, you can request a new one below.</p>

						<div className="resend-row">
							<button type="button" className="resend-button" onClick={handleResendCode} disabled={loading}>{loading ? 'Sending...' : 'Resend code'}</button>
							<span className="back-link back-link-static">Stays on this page</span>
						</div>

						{error && <p className="form-error">{error?.detail || error?.message || error}</p>}
						{message && <p className="form-success">{message}</p>}

						<button type="submit" className="login-button" disabled={loading}>{loading ? 'Verifying...' : 'Verify Email'}</button>
					</form>

					<p className="signup-link">Back to <NavLink to="/sign-in">Sign In</NavLink></p>
				</div>
			</div>
		</div>
	);
};

export default VerifyEmail;
